import { mdiCogOutline } from '@mdi/js'
import { PRIVATE } from '@/plugins/acl/const'

export default [
  {
    subheader: 'settingsHeader',
  },
  {
    title: 'settings',
    icon: mdiCogOutline,
    children: [
      {
        title: 'organization',
        to: 'settings-organization',
        resource: PRIVATE.SETTINGS.COMPANY,
        action: 'read',
      },
      {
        title: 'userManagement',
        to: 'settings-users-list',
        resource: PRIVATE.SETTINGS.USER_MANAGEMENT,
        action: 'read',
      },
      {
        title: 'recruitmentSettings',
        to: 'settings-recruitment',
        resource: PRIVATE.SETTINGS.JOBS,
        action: 'read',
      },
      {
        title: 'legalizationOfStay',
        to: 'settings-legalization-of-stay',
        resource: PRIVATE.SETTINGS.LEGALIZATION_OF_STAY,
        action: 'read',
      },
      {
        title: 'legalizationOfWork',
        to: 'settings-legalization-of-work',
        resource: PRIVATE.SETTINGS.LEGALIZATION_OF_WORK,
        action: 'read',
      },
      {
        title: 'employees',
        to: 'settings-employee',
        resource: PRIVATE.SETTINGS.EMPLOYEES,
        action: 'read',
      },
      {
        title: 'workingTimeRecords',
        to: 'settings-working-time-records',
        resource: PRIVATE.SETTINGS.WORKING_TIME_RECORDS,
        action: 'read',
      },
      {
        title: 'clients',
        to: 'settings-client',
        resource: PRIVATE.SETTINGS.CLIENTS,
        action: 'read',
      },
      {
        title: 'leads',
        to: 'settings-leads',
        resource: PRIVATE.SETTINGS.LEADS,
        action: 'read',
      },
      {
        title: 'workstations',
        to: 'settings-workstations',
        resource: PRIVATE.SETTINGS.PROJECTS,
        action: 'read',
      },
      {
        title: 'apartments',
        to: 'settings-apartments',
        resource: PRIVATE.SETTINGS.HOUSES,
        action: 'read',
      },
      {
        title: 'fleet',
        to: 'settings-fleet',
        resource: PRIVATE.SETTINGS.FLEET,
        action: 'read',
      },
      {
        title: 'resources',
        to: 'settings-resources',
        resource: PRIVATE.SETTINGS.RESOURCES,
        action: 'read',
      },
    ],
  },
]
